import Toggle from './Toggle.vue';

export default Toggle;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/toggle/index.ts